import * as Yup from 'yup';
import checkoutFormModel from './formModel';

const moment = require('moment');

const {
    formField: {
        vehiculo: {
            marca,
            modelo,
            anio,
            version,
            esCeroKm,
            tieneGnc,
            sumaAseguradaGnc,
            sumaAseguradaAdicional
        },
        situacionImpositiva,
        personaJuridica,
        codigosLocalidad,
        vigencia,
        ajusteAutomatico,
        cuotas,
        afinidad,
        fechaCotizacion
    }
} = checkoutFormModel;


export default [
    Yup.object().shape({
        vehiculo: Yup.object().shape({
            marca: Yup.string().required(`${marca.requiredErrorMsg}`),
            ceroKm: Yup.string().required(`${esCeroKm.requiredErrorMsg}`),
            anio: Yup.number()
                .required(`${anio.requiredErrorMsg}`)
                .integer()
                .min(2001, "El año ingresado es muy antiguo")
                .max(moment().format("YYYY"), "Ingrese un año válido")
                .typeError("Ingrese un año válido"),
            modelo: Yup.string().required(`${modelo.requiredErrorMsg}`),
            version: Yup.string().required(`${version.requiredErrorMsg}`),
            tieneGnc: Yup.string().required(`${tieneGnc.requiredErrorMsg}`),
            valorGnc: Yup.string().when('tieneGnc', {
                is: '1',
                then: Yup.string().required(`${sumaAseguradaGnc.requiredErrorMsg}`)
                    .matches(/^[1-9]\d*$/, "El valor ingresado no es válido")
                // .min(4, "El valor ingresado es muy bajo")
            }),
            valorAdicional: Yup.number()
                .required(`${sumaAseguradaAdicional.requiredErrorMsg}`)
                .min(0, "El valor no puede ser negativo")
                .max(10000000, "El monto máximo es $10.000.000")
        }),
    }),
    Yup.object().shape({
        [situacionImpositiva.name]: Yup.string().required(`${situacionImpositiva.requiredErrorMsg}`),
        [personaJuridica.name]: Yup.string().required(`${personaJuridica.requiredErrorMsg}`),
        [codigosLocalidad.name]: Yup.string().required(`${codigosLocalidad.requiredErrorMsg}`),
        [afinidad.name]: Yup.string().required(`${afinidad.requiredErrorMsg}`),
    }),
    Yup.object().shape({
        [ajusteAutomatico.name]: Yup.string().when([vigencia.name], {
            is: '2',
            then: Yup.string().required(`${ajusteAutomatico.requiredErrorMsg}`)
        }),
        [cuotas.name]: Yup.string().when([vigencia.name], {
            is: '2',
            then: Yup.string().required(`${cuotas.requiredErrorMsg}`)
        }),
        [fechaCotizacion.name]: Yup.date()
            .required(`${fechaCotizacion.requiredErrorMsg}`)
            .min(moment().format('YYYY-MM-DD'), "La fecha no puede ser anterior al dia de hoy")
            .max(moment().add(45, "days").format('YYYY-MM-DD'), "La fecha no puede superar los 45 dias"),
    })
];
